<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Browser Notifications</h3>
    <p>Browser Notification Status: {{ status }}</p>
    <a v-if="status === 'default'" href="#" class="button" @click.prevent="requestPermission">Allow Notifcations</a>

    <h3 class="section-title -mb">Email Notifications</h3>

    <form @submit="addEmail">
      <input v-model="newEmail" type="text" />
      <action-button text="Add Email Address" :state="state" @pressed="addEmail"></action-button>
    </form>

    <div v-if="resource.notification_emails && resource.notification_emails.length > 0" class="basic-list -mt">
      <hr />
      <ul>
        <li v-for="(email, index) in resource.notification_emails" :key="email">
          {{ email }}
          <action-button :state="state" text="Remove" class="-danger -small -right" @pressed="removeEmail(email)" />
          <span v-if="dig(errors.notification_emails, index)" class="alert -inline -danger -mt">
            {{ [...dig(errors.notification_emails, index)].join(', ') }}
          </span>
        </li>
      </ul>
    </div>

    <hr />

    <h3 class="section-title -mb">Dealership Notifications</h3>

    <form @submit="setNotificationEmailImageURL">
      <label>
        Team Image URL
        <input v-model="resource.notification_email_image_url" type="url" />
        <span v-if="notificationEmailImageUrlError || errors.notification_email_image_url" class="alert -inline -danger">
          {{ notificationEmailImageUrlError || [...errors.notification_email_image_url].join(', ') }}
        </span>
      </label>
      <action-button
        class="-mt"
        :text="'Update Settings'"
        :state="state"
        @pressed="setNotificationEmailImageURL"
      ></action-button>
    </form>

    <p>
      Note: Dealership notification email addresses are set on each individual
      <router-link to="/dealerships">dealership</router-link> page
    </p>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";
import notifications from "@/helpers/notifications";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["notification_emails", "notification_email_image_url"],
      status: "unavailable",
      newEmail: "",
      notificationEmailImageUrlError: ""
    };
  },

  created() {
    this.status = notifications.permission();
  },

  methods: {
    dig,
    requestPermission() {
      notifications.requestPermission().then((permission) => {
        this.status = permission;

        if (permission === "granted") {
          notifications.notify("Permission granted!");
        }
      });
    },

    addEmail() {
      if (this.newEmail.trim().length > 0) {
        this.resource.notification_emails.push(this.newEmail.trim());
        this.resource.notification_emails = _.uniq(this.resource.notification_emails);

        this.newEmail = "";

        this.submit();
      }
    },

    removeEmail(email) {
      const dupe = _.clone(this.resource);
      dupe.notification_emails = _.without(dupe.notification_emails, email);
      this.resource = dupe;
      this.submit();
    },

    setNotificationEmailImageURL() {
      const url = this.resource.notification_email_image_url;
      // Allow for empty URLs or image urls
      if (
        url.length === 0 ||
        (url.startsWith("http") &&
          (url.endsWith(".jpg") ||
            url.endsWith(".png") ||
            url.endsWith(".gif") ||
            url.endsWith(".webp") ||
            url.endsWith(".svg")))
      ) {
        this.notificationEmailImageUrlError = "";
        this.submit();
      } else {
        this.notificationEmailImageUrlError = "Not an image URL. Must end with .jpg, .png, .gif, .svg or .webp";
      }
    }
  }
};
</script>
